import React, { useContext, createContext } from 'react';

export interface CardContext {
  isDisabled?: boolean;
}

export const CardContext = createContext<CardContext | null>(null);

export const CardContextProvider = (props: { children: React.ReactNode; isDisabled: boolean }): React.ReactElement => {
  const { isDisabled, children } = props;

  const value = { isDisabled };

  return <CardContext.Provider value={value}>{children}</CardContext.Provider>;
};

export const useCardContext = (): CardContext => {
  const context = useContext(CardContext);

  if (context === null) {
    throw new Error(
      'CardContext must be used within a CardContextProvider. Most likely CardContent or another Card sub component is not being used as a child of the Card parent component.'
    );
  }

  return context;
};
